import { SearchPersonItem } from '@/apiTypes/types';

export const getSearchPersonLabel = (person: SearchPersonItem) => `${person.name}${person.age ? ` (${person.age})` : ''}`;
